import { useState } from 'react'
import { getKyousouApiClient, handleError, ApiErrorResponse } from '../../../../services/network'
import { useSnackBar } from '../../../../providers/snack_bar_provider'
import { SlidePartners, PartnersFormData } from './types'
import { AiInstructionFormData } from '../common/types'

export const usePartnersRegenerate = () => {
  const apiClient = getKyousouApiClient()
  const { showSnackBar } = useSnackBar()
  const [isRegenerating, setIsRegenerating] = useState(false)

  const regeneratePartners = async (
    id: string,
    aiInstruction: string,
    setSlidePartners: (slidePartners: SlidePartners) => void,
    resetAiForm: (data: AiInstructionFormData) => void,
    resetForm: (data: PartnersFormData) => void
  ) => {
    if (!aiInstruction.trim() || !id) return

    setIsRegenerating(true)

    try {
      const response = await apiClient.business.slidePartnersRegenerateCreate({
        businessIdeaId: id,
        aiInstruction: aiInstruction,
      })

      if (response.data?.partners) {
        setSlidePartners(response.data.partners)
        resetAiForm({ aiInstruction: '' })
        showSnackBar(['オススメ共創パートナー企業のAI再生成が完了しました'], 'success', null) // 自動で消えない

        try {
          resetForm({
            partners: JSON.parse(response.data.partners.partners || '[]'),
          })
        } catch (parseError) {
          console.error('JSONパースエラー:', parseError)
          showSnackBar(['オススメ共創パートナー企業のデータの読み込みに失敗しました。'], 'error', null) // 自動で消えない
        }
      }
    } catch (e) {
      console.error('オススメ共創パートナー企業のAI再生成に失敗しました:', e)
      handleError(e as ApiErrorResponse, (messages, severity) => {
        showSnackBar(messages, severity, null) // 自動で消えない
      })
    } finally {
      setIsRegenerating(false)
    }
  }

  return {
    isRegenerating,
    regeneratePartners,
  }
}
